import { c as _c } from "react/compiler-runtime";
import React from 'react';
import MobileProductFilterWrapper from './MobileProductFilterWrapper';
import TypeRefinementList from './TypeRefinementList';
const MobileProductFilters = t0 => {
  const $ = _c(3);
  const {
    items,
    refine
  } = t0;
  let t1;
  if ($[0] !== items || $[1] !== refine) {
    t1 = <div><MobileProductFilterWrapper id="type" label="Type"><TypeRefinementList items={items} refine={refine} /></MobileProductFilterWrapper></div>;
    $[0] = items;
    $[1] = refine;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default MobileProductFilters;